import { Modal } from 'components/common'
import { CustomizedModalProps } from './types'

export interface DeleteConfirmationModalProps extends CustomizedModalProps {
  bookingId: string
}

export const DeleteConfirmationModal = ({
  bookingId,
  ...rest
}: DeleteConfirmationModalProps): JSX.Element => (
  <>
    <Modal
      title={`${bookingId} を削除しますか？`}
      okText={'下書き予約を削除する'}
      okType={'primary'}
      okButtonProps={{ danger: true }}
      cancelText={'キャンセル'}
      {...rest}
    >
      下書き予約 {bookingId} を削除してもよろしいですか？
      削除後元に戻すことはできません。
    </Modal>
  </>
)
